import { UserRef } from './bewerber';

// Activity Type enum matching backend
export enum ActivityTyp {
  NOTE = 'NOTE',
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  MEETING = 'MEETING',
}

// Activity interface
export interface Activity {
  id: string;
  bewerberId: string;
  typ: ActivityTyp;
  subject: string | null;
  content: string;
  occurredAt: string;
  duration: number | null;
  metadata: Record<string, unknown> | null;
  createdById: string;
  createdAt: string;
  updatedAt: string;
  createdBy?: UserRef;
}

// Structured change entry for UPDATE system events
export interface FieldChange {
  field: string;
  label: string;
  oldValue: string | null;
  newValue: string | null;
}

// Timeline Event (merged activities + system events)
export interface TimelineEvent {
  id: string;
  type: 'activity' | 'system';
  eventType: string;
  title: string;
  description: string | null;
  occurredAt: string;
  user: UserRef | null;
  metadata?: Record<string, unknown> & {
    changes?: FieldChange[];
  };
}

// Create Activity DTO
export interface CreateActivityDto {
  typ: ActivityTyp;
  subject?: string;
  content: string;
  occurredAt?: string;
  duration?: number;
  metadata?: Record<string, unknown>;
}

// Update Activity DTO
export interface UpdateActivityDto {
  typ?: ActivityTyp;
  subject?: string;
  content?: string;
  occurredAt?: string;
  duration?: number;
  metadata?: Record<string, unknown>;
}

// Query parameters for activities/timeline
export interface QueryActivityDto {
  typ?: ActivityTyp;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

// Activity type display configuration
export const ActivityTypConfig: Record<ActivityTyp, {
  label: string;
  color: string;
  bgColor: string;
  icon: 'note' | 'phone' | 'email' | 'users';
}> = {
  [ActivityTyp.NOTE]: {
    label: 'Notiz',
    color: 'text-blue-700',
    bgColor: 'bg-blue-100',
    icon: 'note',
  },
  [ActivityTyp.CALL]: {
    label: 'Anruf',
    color: 'text-green-700',
    bgColor: 'bg-green-100',
    icon: 'phone',
  },
  [ActivityTyp.EMAIL]: {
    label: 'E-Mail',
    color: 'text-purple-700',
    bgColor: 'bg-purple-100',
    icon: 'email',
  },
  [ActivityTyp.MEETING]: {
    label: 'Meeting',
    color: 'text-orange-700',
    bgColor: 'bg-orange-100',
    icon: 'users',
  },
};

// System event type display configuration
export const SystemEventConfig: Record<string, {
  label: string;
  color: string;
  bgColor: string;
}> = {
  STATUS_CHANGE: {
    label: 'Status geändert',
    color: 'text-gray-700',
    bgColor: 'bg-gray-100',
  },
  DOCUMENT_UPLOAD: {
    label: 'Dokument hochgeladen',
    color: 'text-indigo-700',
    bgColor: 'bg-indigo-100',
  },
  DOCUMENT_DELETE: {
    label: 'Dokument gelöscht',
    color: 'text-red-700',
    bgColor: 'bg-red-100',
  },
  BEWERBER_CREATE: {
    label: 'Bewerber erstellt',
    color: 'text-green-700',
    bgColor: 'bg-green-100',
  },
  BEWERBER_UPDATE: {
    label: 'Bewerber aktualisiert',
    color: 'text-blue-700',
    bgColor: 'bg-blue-100',
  },
};
